import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AdminSetupAddTimeScanTypeComponent } from "./admin-setup-add-time-scan-type/admin-setup-add-time-scan-type.component";
import { AdminSetupEditTimeScanTypeComponent } from "./admin-setup-edit-time-scan-type/admin-setup-edit-time-scan-type.component";
import { DataService_TimeScanTypeSetup } from "./shared/data.service";

@Component({
	selector: "app-time-scan-type-setup",
	templateUrl: "./time-scan-type-setup.component.html",
	styleUrls: ["./time-scan-type-setup.component.css"],
})
export class TimeScanTypeSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private TimeScanTypeSetupService: DataService_TimeScanTypeSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////
	SchoolID: any;
	lstSchool: any = [];

	//Main
	SelectedTimeScanType: any;
	lstTimeScanType: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];
	lstAvailableToDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "TimeScanTypeDesc", header: "Description" },
		{ field: "TimeScanTypeCD", header: "Code" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadTimeScanType();
			},
			(error) => {}
		);
	}

	loadTimeScanType() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.TimeScanTypeSetupService.LoadTimeScanType(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstTimeScanType = response;

				for (var z = 0; z < this.lstTimeScanType.length; z++) {
					var next = this.lstTimeScanType[z];
					next.AvailableToDesc = next.SchoolID == 0 ? "All Schools" : "This School Only";
				}

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstTimeScanType.map((item: any) => item.DefinedByDesc))).sort();
				this.lstAvailableToDesc = Array.from(new Set(this.lstTimeScanType.map((item: any) => item.AvailableToDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadTimeScanType();
	}

	//Custom Button Methods
	onAddTimeScanType() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AdminSetupAddTimeScanTypeComponent, {
			header: "Add Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTimeScanType();
			}
		});
	}

	onEditTimeScanType() {
		this.errorMessage = "";

		if (this.SelectedTimeScanType == undefined) {
			this.errorMessage = "Select a Time Scan Type to edit";
			return;
		}

		//Check permission

		//No one can edit System and imported types
		if (this.SelectedTimeScanType.DefinedByID <= 2) {
			this.errorMessage = "You do not have permission to edit this time scan type";
			return;
		}
		//District users can edit any other types
		//School Users can only edit school level types
		if (this.user.UserLevelID == 3 && this.SelectedTimeScanType.DefinedByID != 3) {
			this.errorMessage = "You do not have permission to edit this time scan type";
			return;
		}

		var ref = this.dialogService.open(AdminSetupEditTimeScanTypeComponent, {
			header: "Edit Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedTST: this.SelectedTimeScanType,
				user: this.user,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTimeScanType();
			}
		});
	}

	onDeleteTimeScanType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedTimeScanType == undefined) {
			this.errorMessage = "Select a Time Scan Type to delete";
			return;
		}

		//Check permission

		//No one can edit System and imported types
		if (this.SelectedTimeScanType.DefinedByID <= 2) {
			this.errorMessage = "You do not have permission to delete this time scan type";
			return;
		}
		//District users can edit any other types
		//School Users can only edit school level types
		if (this.user.UserLevelID == 3 && this.SelectedTimeScanType.DefinedByID != 3) {
			this.errorMessage = "You do not have permission to delete this time scan type";
			return;
		}

		//Call SP
		var result = this.TimeScanTypeSetupService.TimeScanTypeDelete(this.SelectedTimeScanType.TimeScanTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadTimeScanType();
				} else {
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Time Scan Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedTimeScanType = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedTimeScanType = null;
	}
	onRowDblClick(TimeScanType) {
		this.errorMessage = "";

		this.SelectedTimeScanType = TimeScanType;
		this.onEditTimeScanType();
	}
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadTimeScanType();
	}
	////////////////////////////////////////////
}
